import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import DatePicker from "react-datepicker"
import { Modal, Dropdown } from 'react-bootstrap'
import Select from 'react-select'

import { httpOk, GET } from 'helpers/api'
import { formatMoney, returnSign, formatDate, findKeyFromArrayByValue, copyText, filterDates, FILTER_DATE } from 'helpers/helpers'

function BalanceDetails({ filterDataParent, setFilterDataParent, poses, wms }) {
	const { t } = useTranslation()

	const [filterData, setFilterData] = useState({
		start_date: formatDate(new Date(), 'yyyy-MM-dd'),
		end_date: formatDate(new Date(), 'yyyy-MM-dd'),
		pos_id: filterDataParent.pos_id,
		wms_id: filterDataParent.wms_id,
		search: '',
	})
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [selectedItem, setSelectedItem] = useState({});
	const [activeTab, setActiveTab] = useState('detail');

	async function searchWithFilter() {
		var filterUrl = "/report-balance-details"
		var urlParams = ""
		var filterDataCopy = { ...filterData }

		urlParams += returnSign(urlParams) + 'type=' + activeTab
		urlParams += returnSign(urlParams) + 'element_id=' + filterDataParent.element_id

		if (filterDataParent.pos_id)
			urlParams += returnSign(urlParams) + 'pos_id=' + filterDataParent.pos_id
		if (filterDataCopy.wms_id)
			urlParams += returnSign(urlParams) + 'wms_id=' + filterDataCopy.wms_id
		if (filterDataCopy.start_date)
			urlParams += returnSign(urlParams) + 'start_date=' + filterDataCopy.start_date
		if (filterDataCopy.end_date)
			urlParams += returnSign(urlParams) + 'end_date=' + filterDataCopy.end_date

		filterUrl = filterUrl + urlParams

		const response = await GET(filterUrl, {}, { loader: true })
		if (httpOk(response)) {
			setSelectedItem(response.data)
		}

		setDropdownIsOpen(false)
	}

	function toggleDropdown() {
		setDropdownIsOpen(!dropdownIsOpen)
	}

	function handleSelectFastDate(option) {
		var obj = filterDates(option.id)
		setFilterData({
			...filterData,
			'start_date': obj.start_date,
			'end_date': obj.end_date,
			'fast_date_id': option.id,
		})
	}

	function returnStyle(item) {
		var myClass = ""
		if (item.key === 'documents_in') {
			myClass = 'bg-success text-white'
			return myClass
		}
		if (item.key === 'inventory') {
			myClass = 'bg-warning text-white'
			return myClass
		}
		if (
			item.key === 'write_off' ||
			item.key === 'transfer_wms_to_wms' ||
			item.key === 'transfer_pos_to_pos' ||
			item.key === 'transfer_pos_to_external_pos'
		) {
			myClass = 'bg-danger text-white'
			return myClass
		}
	}

	useEffect(() => {
		if (!filterDataParent.modalProducts)
			setSelectedItem({})
	}, [filterDataParent.modalProducts]) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		searchWithFilter()
	}, [activeTab]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			{/* MODAL */}
			<Modal show={filterDataParent.modalProducts} animation={false} centered size="xl"
				onHide={() => setFilterDataParent({ ...filterDataParent, 'modalProducts': false })}>
				<Modal.Header closeButton>
					<Modal.Title>{t('information')}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<>
						<div className="d-flex mb-3">
							<div className="d-flex flex-wrap gap-2">
								<div>
									<Dropdown onToggle={toggleDropdown} show={dropdownIsOpen}>
										<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100">
											{t('filter')}
										</Dropdown.Toggle>

										<Dropdown.Menu className="dropdown-filter">
											<div className="row">
												<div className="form-group col-md-6">
													<label>{t('wms')}</label>
													<Select
														// isClearable
														options={wms}
														value={wms.find(option => option.id === filterData.wms_id) || ''}
														onChange={(option) => setFilterData({ ...filterData, 'wms_id': option ? option.id : null })}
														placeholder=""
														noOptionsMessage={() => t('list_empty')}
														getOptionLabel={(option) => option.name}
														getOptionValue={(option) => option.id}
													/>
												</div>
											</div>
											<div className="row">
												<div className="form-group col-md-4">
													<label>{t('date')}</label>
													<Select
														options={FILTER_DATE}
														value={FILTER_DATE.find(option => option.id === filterData.fast_date_id) || ''}
														onChange={(option) => handleSelectFastDate(option)}
														placeholder=""
														noOptionsMessage={() => t('list_empty')}
														getOptionLabel={(option) => option.name}
														getOptionValue={(option) => option.id}
													/>
												</div>
												<div className="form-group col-md-4">
													<label>{t('period')}</label>
													<div className="calendar-input">
														<DatePicker
															className="form-control"
															dateFormat="dd.MM.yyyy"
															selected={filterData.start_date ? new Date(filterData.start_date) : ''}
															onChange={(date) => setFilterData({ ...filterData, 'start_date': formatDate(date, 'yyyy-MM-dd') })} />
														<i className="uil uil-calendar-alt"></i>
													</div>
												</div>
												<div className="form-group col-md-4">
													<label className="invisible">.</label>
													<div className="calendar-input">
														<DatePicker
															className="form-control"
															dateFormat="dd.MM.yyyy"
															selected={filterData.end_date ? new Date(filterData.end_date) : ''}
															onChange={(date) => setFilterData({ ...filterData, 'end_date': formatDate(date, 'yyyy-MM-dd') })} />
														<i className="uil uil-calendar-alt"></i>
													</div>
												</div>
											</div>
											<div className="row mt-3">
												<div className="col-md-12">
													<div className="d-flex justify-content-end gap-2">
														<button className="btn btn-secondary"
															onClick={() => setDropdownIsOpen(false)}>
															{t('cancel')}
														</button>
														<button className="btn btn-primary"
															onClick={() => searchWithFilter(false)}>
															{t('apply')}
														</button>
													</div>
												</div>
											</div>
										</Dropdown.Menu>
									</Dropdown>
								</div>
								<button className={`btn ${activeTab === 'detail' ? 'btn-primary' : 'btn-secondary'}`}
									onClick={() => setActiveTab('detail')}>
									{t('in_detail')}
								</button>
								<button className={`btn ${activeTab === 'checkpoint' ? 'btn-primary' : 'btn-secondary'}`}
									onClick={() => setActiveTab('checkpoint')}>
									{t('check_point')}
								</button>
							</div>
						</div>

						<div className="filter-block">
							<div className="filter">
								<strong>{t('filter')}</strong>
								<br />
								{(filterData.start_date || filterData.end_date) &&
									<span className="me-2">
										<b>{t('period')}: </b>
										{filterData.start_date &&
											<span>{formatDate(filterData.start_date)}</span>
										}
										{(filterData.start_date && filterData.end_date) &&
											<span>|</span>
										}
										{filterData.end_date &&
											<span>{formatDate(filterData.end_date)}</span>
										}
									</span>
								}
								{filterDataParent.pos_id &&
									<span className="me-2">
										<b>{t('pos')}: </b>
										{findKeyFromArrayByValue(poses, 'id', filterDataParent.pos_id, 'name')}
									</span>
								}
							</div>
						</div>
					</>

					{activeTab === 'detail' &&
						<div className="row">
							<div className="table-responsive table-fixed" style={{ 'height': '500px', 'overflow': 'auto' }}>
								<table className="table table-bordered mb-0">
									<thead>
										<tr>
											<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
											<th style={{ 'width': '20%' }}>{t('type')}</th>
											<th style={{ 'width': '20%' }}>{t('element')}</th>
											<th style={{ 'width': '20%' }}>{t('product')}</th>
											<th style={{ 'width': '10%' }} className="text-end text-nowrap">{t('quantity')}</th>
											<th style={{ 'width': '10%' }} className="text-end text-nowrap">{t('balance2')}</th>
											<th style={{ 'width': '20%' }} className="text-end text-nowrap">{t('date')}</th>
										</tr>
									</thead>
									<tbody>
										{selectedItem?.combined?.map((item, index) => (
											<tr key={index}>
												<td className={`text-center ${returnStyle(item)}`}
													title={item.cheque_id}
													onClick={() => copyText(item.cheque_id)}>
													{index + 1}
												</td>
												<td className="td-ellipsis">
													{item.key === 'inventory' &&
														<span>{t('inventory')}</span>
													}
													{item.key === 'sales' &&
														<span>{t('sales')}</span>
													}
													{item.key === 'documents_in' &&
														<span>{t('good_reception')}</span>
													}
													{item.key === 'write_off' &&
														<span>{t('write_off')}</span>
													}
													{item.key === 'transfer_pos_to_pos' &&
														<span>{t('transfer_between_branches')}</span>
													}
													{item.key === 'transfer_pos_to_external_pos' &&
														<span>{t('moving_another_store')}</span>
													}
													{item.key === 'transfer_wms_to_wms' &&
														<span>{t('transfer_between_wms')}</span>
													}
												</td>
												<td className="td-ellipsis">{item.element_name}</td>
												<td className="td-ellipsis">{item.product_name}</td>
												<td className="text-end">{formatMoney(item.quantity, 3)}</td>
												<td className="text-end">{formatMoney(item.balance, 3)}</td>
												<td className="text-end">{formatDate(item.created_at, 'dd.MM.yy HH:mm:ss')}</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</div>
					}

					{activeTab === 'checkpoint' &&
						<div className="row">
							<div className="table-responsive table-fixed" style={{ 'height': '500px', 'overflow': 'auto' }}>
								<table className="table table-bordered mb-0">
									<thead>
										<tr>
											<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
											<th style={{ 'width': '10%' }} className="td-ellipsis" title={t('date')}>{t('date')}</th>
											<th style={{ 'width': '10%' }} className="td-ellipsis" title={t('balance2')}>{t('balance2')}</th>
											<th style={{ 'width': '10%' }} className="td-ellipsis" title={t('good_reception')}>{t('good_reception')}</th>
											<th style={{ 'width': '10%' }} className="td-ellipsis" title={t('sales')}>{t('sales')}</th>
											<th style={{ 'width': '10%' }} className="td-ellipsis" title={t('inventory')}>{t('inventory')}</th>
											<th style={{ 'width': '10%' }} className="td-ellipsis" title={t('write_off')}>{t('write_off')}</th>
											<th style={{ 'width': '10%' }} className="td-ellipsis" title={t('transfer_between_branches')}>{t('transfer_between_branches')}</th>
											<th style={{ 'width': '10%' }} className="td-ellipsis" title={t('moving_another_store')}>{t('moving_another_store')}</th>
											<th style={{ 'width': '10%' }} className="td-ellipsis" title={t('transfer_between_wms')}>{t('transfer_between_wms')}</th>
											<th style={{ 'width': '10%' }} className="td-ellipsis text-end" title={t('balance2')}>{t('balance2')}</th>
										</tr>
									</thead>
									<tbody>
										{selectedItem?.balanceDaily?.map((item, index) => (
											<tr key={index}>
												<td className="text-center">{index + 1}</td>
												<td className="text-nowrap">{formatDate(item.date, 'dd.MM.yy')}</td>
												<td>{formatMoney(item.start_balance, 3)}</td>
												<td className="text-success">{formatMoney(item.incoming, 3)}</td>
												<td className="text-danger">{formatMoney(item.sold, 3)}</td>
												<td className="text-warning">{formatMoney(item.inventory, 3)}</td>
												<td className="text-danger">{formatMoney(item.write_off, 3)}</td>
												<td className="text-danger">{formatMoney(item.transfer_pos_to_pos, 3)}</td>
												<td className="text-danger">{formatMoney(item.transfer_pos_to_external, 3)}</td>
												<td className="text-danger">{formatMoney(item.transfer_wms_to_wms, 3)}</td>
												<td className="text-end">{formatMoney(item.end_balance, 3)}</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</div>
					}
				</Modal.Body>
			</Modal >
			{/* MODAL */}
		</>
	)
}

export default BalanceDetails